// libs
import { useDispatch, useSelector } from 'react-redux'

// interfaces
import { IUser } from 'src/interfaces/user'
import { IRootState } from 'src/reducers/interface'

// helpers
import { useAuthLogin, useUser } from '@lopo-tech/lopo-api'
import { USER_SET_SELECTED_PROFILE } from 'src/actions/user/user'
import { getProfileStatus, isIntermediateProfile } from 'src/utils/profile'
import { useGetAppLocationShape } from '../app-state/app-state_hooks'

export const useSelectUser = () => useSelector<IRootState, IUser>(({ user }) => user)

export const useSelectUserMail = () => useSelector<IRootState, string | undefined>(({ user }) => user.email)

export const useSelectIsUserLoggedIn = () => {
  const { isAuthenticated } = useAuthLogin()
  return isAuthenticated
}

export const useSelectCurrentProfileId = () => {
  const selectedProfileId = useSelector<IRootState, string>(({ user }) => user.selectedProfileId)
  const dispatch = useDispatch()

  const setCurrentProfileId = (profileId: string | null) => {
    dispatch({ type: USER_SET_SELECTED_PROFILE, payload: profileId })
  }

  return { currentProfileId: selectedProfileId, setCurrentProfileId }
}

export const useSelectCurrentProfile = () => {
  const isLoggedIn = useSelectIsUserLoggedIn()
  const { data } = useUser({ skip: !isLoggedIn })
  return data?.currentProfile
}

export const useSelectUserLocationShape = () => useSelectCurrentProfile()?.address?.locationShape

export const useIsUserHome = () => {
  const appLocationShape = useGetAppLocationShape()
  const locationShape = useSelectUserLocationShape()

  return !!locationShape?.id && locationShape.id === appLocationShape?.id
}

export const useSelectProfileStatus = () => {
  return useSelector(getProfileStatus)
}

export const useIsIntermediateProfile = () => {
  const userType = useSelectCurrentProfile()?.__typename
  return isIntermediateProfile(userType)
}
